import { Component } from '@angular/core';

@Component({
  selector: 'lib-widget',
  imports: [],
  template: `
    <p>
      widget works!
    </p>
  `,
  styles: ``
})
export class Widget {

}
